// ignore-string-externalization

import React from 'react';
import styled from 'styled-components';
import {
  screenSmMax,
  screenMdMin,
  spacer8,
  spacer16,
  spacer24,
  spacer40,
  makeColorSetClass,
  cssColorValue,
  screenXsMax,
  screenSmMin,
} from '@spotify-internal/encore-web';
import { ModuleType } from '../types';
import { ContentfulAsset } from '../../Contentful';
import { FeaturedContentHeadline } from '../../ui';
import { ThreeUpSegment } from './ThreeUpSegment';
import { MODULE_COLOR_SETS } from '../../Theme';

const Wrapper = styled.div`
  background-color: ${cssColorValue('backgroundBase')};
  @media (max-width: ${screenXsMax}) {
    padding: ${spacer24} ${spacer16};
  }

  @media (min-width: ${screenSmMin}) {
    padding: ${spacer24} ${spacer40};
  }
`;

const ThreeUp = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: ${spacer24};

  & h1,
  h2 {
    padding-top: ${spacer16};
    padding-bottom: ${spacer8};
  }

  @media (min-width: ${screenMdMin}) {
    & h1 {
      padding-bottom: ${spacer40};
    }
  }

  @media (max-width: ${screenSmMax}) {
    padding-bottom: ${spacer8};

    [data-aspect-ratio='21x9'] {
      order: 1;
    }
  }
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: ${screenSmMax}) {
    flex-direction: column;
    gap: ${spacer40};
  }
`;

const SegmentWrapper = styled.div`
  width: 25%;

  @media (max-width: ${screenSmMax}) {
    width: 100%;
  }
`;

type ThreeUpModuleType = ModuleType & {
  headline?: string;
  image?: ContentfulAsset;
  caption?: string;
  supertext?: string;
  segments?: {
    headline?: string;
    body?: string;
    image?: ContentfulAsset;
  }[];
};

export const ThreeUpModule = React.forwardRef<
  React.MutableRefObject<ModuleType>,
  ThreeUpModuleType
>(
  (
    {
      headline = '',
      supertext = '',
      image,
      caption = '',
      segments = [],
      themeName,
    },
    ref,
  ) => {
    const fchProps = {
      headline,
      supertext,
      image,
      useFeaturedContentHeadline: true,
      caption,
    };
    return (
      <Wrapper
        className={makeColorSetClass(
          MODULE_COLOR_SETS[themeName || 'whiteOnBlack'],
        )}
      >
        <ThreeUp ref={ref as React.RefObject<HTMLDivElement>}>
          <FeaturedContentHeadline {...fchProps} />
          <Bottom>
            {segments.map(segment => (
              <SegmentWrapper key={segment.headline}>
                <ThreeUpSegment threeUpSegment={segment} />
              </SegmentWrapper>
            ))}
          </Bottom>
        </ThreeUp>
      </Wrapper>
    );
  },
);
